import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { DropdownItem } from '@/main/store/@types/dropdown.d';

import { NAME as name, CRUMB_LABEL_KEY as crumbLabel } from '../constants';
import { apiProvider } from '../api';
import { types } from './types';

export interface CheckboxItem {
	Acces: boolean,
	Text: string,
	VybCheckbox: boolean,
	ZvlnabidkaOzn: string,
}

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel,
	dropdownList: {
		CaswId: [] as (DropdownItem & { CaswPznText: string })[],
	},
	edit: {
		PracovnikId: null as number | null,
		PracovnikIdOsobniCis: null as string | null,
		PracovnikIdText: null as string | null,
		CaswId: null as number | null,
		ZakazkaId: null as number | null,
		ZakazkaDruh: null as string | null,
		ZakazkaIdText: null as string | null,
		ZakazkaNr: null as number | null,
		ZacatekDat: null as Date | null,
		PrescasPrp: false as boolean,
		VstupDat: null as Date | null,
		VstupPracIdText: null as string | null,
		EditDat: null as Date | null,
		EditPracIdText: null as string | null,
	},
	depTableNames: [],
	depTableSettings: {},
	localState: {},
	extraActions: {},
	extraGetters: {},
	extraMutations: {
		[types.mutations.PRACOVNIK_SELECT_MAPPER](state, { data }) {
			state.edit.PracovnikId = data.value;
			state.edit.PracovnikIdText = data.jmeno || data.text ? `${data.text} ${data.jmeno}` : null;
			state.edit.PracovnikIdOsobniCis = data.osobniCis;
		},
		[types.mutations.ZAKAZKA_SELECT_MAPPER](state, { data }: any) {
			state.edit.ZakazkaId = data.value;
			state.edit.ZakazkaNr = data.nr;
			state.edit.ZakazkaIdText = data.text;
		},
	},
	props: {
		mode: null,
	},
});
